import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ProductDetailNavigationState from "@sonic/Store/Components/ProductDetailNavigation/ProductDetailNavigationState";
import { mappedAnchorLink } from "@sonic/Widgets/Common/AnchorNavigation";
import { Draft } from "immer";

const initialState: ProductDetailNavigationState = {
    navigationLinks: [],
};

const reducer = {
    "Components/ProductDetailNavigation/UpdateProductDetailNavigationState": (
        draft: Draft<ProductDetailNavigationState>,
        action: { parameter: ProductDetailNavigationState },
    ) => {
        draft.navigationLinks = [...draft.navigationLinks, ...action.parameter.navigationLinks];
    },
    "Components/ProductDetailNavigation/ResetProductDetailNavigationState": (
        draft: Draft<ProductDetailNavigationState>,
    ) => {
        draft.navigationLinks = [];
    },
    "Components/ProductDetailNavigation/ChangeProductDetailNavigationState": (
        draft: Draft<ProductDetailNavigationState>,
        action: { parameter: mappedAnchorLink },
    ) => {
        draft.navigationLinks = draft.navigationLinks.map(link =>
            link.contentID === action.parameter.contentID ? action.parameter : link,
        );
    },
    "Components/ProductDetailNavigation/SortProductDetailNavigationState": (
        draft: Draft<ProductDetailNavigationState>,
        action: { parameter: mappedAnchorLink },
    ) => {
        draft.navigationLinks.sort((a, b) => a.sortOrder - b.sortOrder);
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
